export * from "./MedicalCard.async";
